const API_PROCESS_LIST = {
  /** 流程控制--接口API */
  queryDictsByDictTypes: 'eigpay.scp.portalmng.elementGroupService.queryDictsByDictTypes', // 查询字典列表
  searchFlowDef: 'eigpay.scp.epfmng.searchFlowDef', // 查询流程配置管理列表
  publishFlow: 'eigpay.scp.epfmng.publishFlow', // 发布流程配置
  deleteFlowDefine: 'eigpay.scp.epfmng.deleteFlowDefine', // 删除单条流程配置
  saveFlow: 'eigpay.scp.epfmng.saveFlow', // 保存流程配置
  selectActiviti: 'eigpay.scp.epfmng.activitiService.selectActiviti', // 查询activiti列表
  createActiviti: 'eigpay.scp.epfmng.activitiService.createActiviti', // 查询activiti列表
  deleteActiviti: 'eigpay.scp.epfmng.activitiService.deleteActiviti', // 删除activiti
  deployActiviti: 'eigpay.scp.epfmng.activitiService.deployActiviti', // 发布activiti
  findProcessDefinition: 'eigpay.scp.epfmng.activitiService.findProcessDefinition', // 查询流程定义管理列表
  deleteProcessDefinition: 'eigpay.scp.epfmng.activitiService.deleteProcessDefinition', // 删除单条流程定义
  searchElePage: 'eigpay.scp.userCenter.elementService.searchPage'
};

// API
const API = (() => {
  Object.keys(API_PROCESS_LIST).forEach(
    key => (API_PROCESS_LIST[key] = { operationType: API_PROCESS_LIST[key] })
  );
  return API_PROCESS_LIST;
})();

export default API;
